import React, { FC, HTMLAttributes } from 'react';
import cn from 'classnames';
import style from './style.module.scss';

type TTitle = {
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h5' | 'h6' | 'div';
  underline?: boolean;
} & HTMLAttributes<HTMLHeadingElement>;

const Title: FC<TTitle> = ({
  tag = 'h1',
  underline = false,
  children,
  className,
  ...restProps
}) => {
  const Tag = tag;

  return (
    <Tag
      className={cn(style[tag], { [style.underline]: underline }, className)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
    >
      {children}
    </Tag>
  );
};

export default Title;
